import { Constants } from 'constants';

import React from 'react';
import { Grid } from '@genie-ui/react';
import PropTypes from 'prop-types';

import ConfigPath from 'configpath';
import useIsFromConferenceApp from 'hooks/usePlatform';
import { useSelector } from 'react-redux';

import './FooterTop.scss';

const isInvitationRoute = window?.location?.pathname?.includes(Constants.URLs.INVITATION);
function FooterTop({
  actisKey,
  actisDataObj,
}) {
  const { user } = useSelector((state) => state.auth);
  const year = new Date().getFullYear();
  const footerText = Constants.LABELS.FOOTER_TEXT.replace(Constants.LABELS.YEAR, year);
  const isFromConferenceApp = useIsFromConferenceApp();

  const handleClick = (event) => {
    const actisLookupTable = {
      POLICIES: Constants.ACTIS.POLICIES,
      'PRIVACY POLICY': Constants.ACTIS.PRIVACY_POLICY,
      'TERMS OF USE': Constants.ACTIS.TERMS_OF_USE,
      OMBUDS: Constants.ACTIS.OMBUDS,
    };

    window.pushEvent?.({
      ...actisLookupTable[event.target.innerText],
      ...actisDataObj,
      ...(isInvitationRoute && {
        eventParticipantEmail: user?.eventParticipantEmail,
      }),
    }, actisKey);
  };

  const renderGlossary = () => Constants.FOOTER.map((item) => (
    <li key={item.label}>
      <a
        href={ConfigPath.GARTNER_URL + item.url}
        rel="noopener noreferrer"
        target={!isFromConferenceApp ? '_blank' : '_self'}
        className="footer__footerLink"
        onClick={handleClick}
      >
        {item.label}
      </a>
    </li>
  ));

  return (
    <Grid className="footer">
      <footer className="footerContainer">
        <nav className="footer__footerPanel">
          <ul className="footer__glossary">
            {renderGlossary()}
          </ul>
        </nav>
        <div className="footer__footerText">{footerText}</div>
      </footer>
    </Grid>
  );
}

FooterTop.propTypes = {
  actisKey: PropTypes.string,
  actisDataObj: PropTypes.instanceOf(Object),
};

FooterTop.defaultProps = {
  actisKey: '',
  actisDataObj: {},
};

export default FooterTop;
